export namespace MandantenConstants {
    export const BENUTZER_BERECHTIGUNGEN = 'benutzerberechtigungen';
    
}

